import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { Activity, ActivityAdditionalInfo, AdditionalInfo, ConfigurationApi, LookupField } from 'src/app/core/api.gen';
import { LoaderService } from 'src/app/core/loader.service';
import { EmployeeCategory, PreBoardingTypesIT, PreBoardingTypes, InternalTransferPBType } from 'src/app/shared/status-types';

@Component({
  selector: 'eos-task-amendment-edit',
  templateUrl: './task-amendment-edit.component.html',
  styleUrls: ['./task-amendment-edit.component.css']
})
export class TaskAmendmentEditComponent implements OnInit {
  activity: Activity;
  countries: LookupField[] = [];
  employeeCategories: LookupField[] = [];
  preboardingTypes: LookupField[] = [];
  yesNo = [{
    value: true,
    displayText: 'Yes',
  }, {
    value: false,
    displayText: 'No'
  }];

  isEdit = true;
  withinSameOffice = false;
  activityTypes: any[] = [];

  createForm = new UntypedFormGroup({
    activityType: new UntypedFormControl(101, [Validators.required]),
    order: new UntypedFormControl(null, [Validators.required]),
    header: new UntypedFormControl(null, [Validators.required]),
    description: new UntypedFormControl(null, [Validators.required]),
    pbTypeId: new UntypedFormControl(null, [Validators.required]),
    additionalInfo: new UntypedFormControl(null),
    isActive: new UntypedFormControl(true, [Validators.required]),
    propertyExtensions: new UntypedFormControl(),
    countryIds: new UntypedFormControl(true, [Validators.required]),
    employeeCategoryIds: new UntypedFormControl([], [Validators.required]),
    withinSameOffice: new UntypedFormControl(false, [Validators.required]),
  });

  amendForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
    header: new UntypedFormControl(null, [Validators.required]),
    activityType: new UntypedFormControl(101),
    order: new UntypedFormControl(null, [Validators.required]),
    description: new UntypedFormControl(null, [Validators.required]),
    pbTypeId: new UntypedFormControl(),
    propertyExtensions: new UntypedFormControl(),
    additionalInfo: new UntypedFormControl(),
    isActive: new UntypedFormControl(),
  });

  constructor(
    private configurationService: ConfigurationApi,
    private loader: LoaderService,
    public modal: NgbActiveModal,
    private toast: ToastService,
  ) { }

  ngOnInit() {
    this.valueChangesSubscriptions();
    if (this.activity) {

      this.activity.pbTypeId = this.activity.pbTypeId === 1079 ? 1045 : 1046;

      this.amendForm.patchValue(this.activity);
      this.createForm.patchValue(this.activity);
      this.createForm.patchValue({
        countryIds: this.activity.additionalInfo.countries,
        employeeCategoryIds: this.activity.additionalInfo.employeeCategories,
        withinSameOffice: this.withinSameOffice
      });
    }
  }

  onSave() {
    this.loader.show();
    this.configurationService.amendCandidateActivity(this.amendForm.getRawValue())
      .pipe(finalize(() => {
        this.loader.clear();
      }))
      .subscribe(resp => {
        if (resp) {
          this.toast.success('Activity successfully updated');
        }
      }, err => {
        this.toast.error('An error occurred. Please try again.');
      }
      );
  }

  getSharedCountries() {
    return this.countries
      .filter(country => this.activity.additionalInfo.countries.includes(country.id))
      .map(country => country.displayText).join(', ');
  }

  createActivity() {
    this.loader.show();

    const rawValues = this.createForm.getRawValue();
    const listOfActivities: Activity[] = [];

    if (rawValues.employeeCategoryIds.includes(EmployeeCategory.INTERNAL_TRANSFER)) {
      if (rawValues.withinSameOffice) {
        const internalAct = new Activity(
          {
            activityType: rawValues.activityType,
            order: rawValues.order,
            header: rawValues.header,
            description: rawValues.description,
            propertyExtensions: rawValues.propertyExtensions,
            pbTypeId: InternalTransferPBType.CommonInternalTranfserPBTypeID,
            additionalInfo: new ActivityAdditionalInfo({
              countries: rawValues.countryIds,
              employeeCategories: [EmployeeCategory.INTERNAL_TRANSFER],
              preboardingTypeId: [rawValues.pbTypeId],
              transferTypes: [PreBoardingTypesIT.Within_Same_Office]
            })

          });
        listOfActivities.push(internalAct);
      } else {
        const internalAct = new Activity(
          {
            activityType: rawValues.activityType,
            order: rawValues.order,
            header: rawValues.header,
            description: rawValues.description,
            propertyExtensions: rawValues.propertyExtensions,
            pbTypeId: InternalTransferPBType.CommonInternalTranfserPBTypeID,
            additionalInfo: new ActivityAdditionalInfo({
              countries: rawValues.countryIds,
              employeeCategories: [EmployeeCategory.INTERNAL_TRANSFER],
              preboardingTypeId: [rawValues.pbTypeId],

            })
          });
        listOfActivities.push(internalAct);
      }
    }

    if (rawValues.employeeCategoryIds.filter(item => item !== EmployeeCategory.INTERNAL_TRANSFER).length) {
      const restOfActivity = new Activity(
        {
          activityType: rawValues.activityType,
          order: rawValues.order,
          header: rawValues.header,
          description: rawValues.description,
          propertyExtensions: rawValues.propertyExtensions,
          pbTypeId: rawValues.pbTypeId,
          additionalInfo: new ActivityAdditionalInfo({
            countries: rawValues.countryIds,
            employeeCategories: rawValues.employeeCategoryIds.filter(emp => emp !== EmployeeCategory.INTERNAL_TRANSFER),
          })
        });
      listOfActivities.push(restOfActivity);
    }

    this.configurationService.createCandidateActivity(listOfActivities)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(resp => {
        this.toast.success('Successfully created');
        this.modal.dismiss();
      }, err => this.toast.success('Error in creating activity')
      );
  }

  valueChangesSubscriptions() {
    this.createForm.controls['activityType'].disable();

    this.createForm.controls['withinSameOffice'].disable();

    this.createForm.controls['employeeCategoryIds'].valueChanges.subscribe(val => {
      if (val.includes(717)) {
        this.createForm.controls['withinSameOffice'].enable();

      } else {
        this.createForm.controls['withinSameOffice'].disable();
        this.createForm.patchValue({
          withinSameOffice: false
        });
      }
    });

  }
}
